//import flatpickr from 'flatpickr';
//import rangePlugin from 'flatpickr/dist/plugins/rangePlugin';

export default {
  finalize() {
    /* global flatpickr, rangePlugin, locale */
    const datePicker = flatpickr('#checkin', {
      mode: 'range',
      minDate: 'today',
      locale: locale.current,
      formatDate: dateObj => dateObj.toLocaleDateString(locale.current),
      'plugins': [new rangePlugin({input: '#checkout'})],
    });

    window.booking = window.bookingWidget || {};
    window.booking.submit = function () {

      if(datePicker.selectedDates[0] === undefined || datePicker.selectedDates[1] === undefined){
        alert(locale.please_select_dates);
        return; 
      }


      const hotelCode = parseInt(document.getElementById('hotel_code').value);
      const checkin = datePicker.selectedDates[0].yyyymmdd();
      const checkout = datePicker.selectedDates[1].yyyymmdd();
      const adults = parseInt(document.getElementById('adults').value);
      const children = parseInt(document.getElementById('children').value);
      const childrenage = document.getElementsByName('childrenage[]');

      const channelCode = hotelCode > 0 && locale.hotel_data[hotelCode] ?
        locale.hotel_data[hotelCode].codice_canale : '1244';

      let ages = '';
      if (childrenage.length > 0) {
        ages = '&ages=';
        for (let i = 0; i < childrenage.length; i++) {
          ages += childrenage[i].value + ',';
        }
        ages = ages.slice(0, -1);
      }

      /*

      LINK GRUPPO 

https://book.ermeshotels.com/channel/1244/language/2 (Italiano)
https://book.ermeshotels.com/channel/1244/language/1 (Inglese)
      
      */

      let  base_ermes_url = locale.ermes_base_url;

      if(hotelCode > 0 ){
       base_ermes_url = base_ermes_url.replace('/#', '/#/hotel/' + hotelCode).replace('/?', '/rooms/?');
      }

      if(channelCode > 0 ){
       base_ermes_url = base_ermes_url.replace('CODICECANALE', channelCode);
      } 

      // debugger;
      window.open(base_ermes_url + 'arrival=' + checkin + '&departure=' + checkout + '&adults=' + adults + '&childs=' + children + ages, '_blank');
    }
  },
};

